import { Pipe, PipeTransform } from '@angular/core';
import { SystemEntity } from '../../models/shared-api-models';
import { TranslationsService } from '../../services/translations';

@Pipe({
    name: 'translateEntityType',
})
export class TranslateEntityTypePipe implements PipeTransform {
    constructor(private translationsService: TranslationsService) {}

    transform(value: SystemEntity, plural = false): string {
        if (!value) {
            return '';
        }

        return this.translationsService.getTranslatedEntityType(value, plural);
    }
}
